<template>
  <div class="ex-questions">
      <!-- :isOpenBookCats="false" -->
    <Viewer
      :valOpenSidebar="typeOpenSidebar"
      :linkBack="examInfo ? { name:'exercise', query:{ lop: examInfo.classId, mon: examInfo.subjectId, tab: typeId} } : {}"
      @scrollBody="handleScrollBodyQuestion"
    >
      <template v-if="examInfo" v-slot:viewer_head_name>{{ examInfo.name }}</template>
      <template v-if="examInfo" v-slot:viewer_head_right>
        <span v-if="examInfo && examInfo.isWork && examInfo.isWork === statusExamDone">{{ examInfo.timeToDo }} : 00</span>
        <CountDown v-else-if="totalTimeToDo > 0" :totalTime="totalTimeToDo" @theEnd="handleEndTime" />
        <span v-else-if="totalTimeToDo < 1">00: 00</span>
      </template>
      <template v-slot:viewr_body>
        <transition name="fade-transform" mode="out-in">
          <div class="exercise-detail__wrap">
            <div class="exercise-result" v-if="examInfo && examInfo.isWork && examInfo.isWork === statusExamDone">
              <div class="exercise-detail__questions">
                <div class="exercise-result__head">
                  <h2 class="font-sanpro-semibold font-size-22 primary-color-txt margin-0">Kết quả</h2>
                </div>
                <div class="exercise-result__body" v-if="examInfo">
                  <div class="row">
                    <div class="col-lg-3 item">
                      <label class="item__label">Điểm</label>
                      <span class="item__content item__content--score">{{ examInfo.score.toFixed(1) }} / 10</span>
                    </div>
                    <div class="col-lg-9">
                      <div class="exercise-result__body__wrap">
                        <div class="row">
                          <div class="col-lg-4 col-sm-6 item">
                            <label class="item__label">Số câu đúng:</label>
                            <span class="item__content">{{ examInfo.totalCorrectAnswers }} / {{ examInfo.totalQuestion }}</span>
                          </div>
                          <div class="col-lg-4 col-sm-6 item">
                            <label class="item__label">Số câu sai:</label>
                            <span class="item__content">{{ examInfo.totalInCorrectAnswers }} / {{ examInfo.totalQuestion }}</span>
                          </div>
                          <div class="col-lg-4 col-sm-6 item">
                            <label class="item__label">Số câu đã làm:</label>
                            <span class="item__content">{{ examInfo.totalAnswers }} / {{ examInfo.totalQuestion }}</span>
                          </div>
                          <div class="col-lg-4 col-sm-6 item">
                            <label class="item__label">Ngày làm:</label>
                            <span class="item__content">{{ moment(examInfo.examDate).format('HH:mm - DD/MM/YYYY') }}</span>
                          </div>
                          <div class="col-lg-4 col-sm-6 item">
                            <label class="item__label">Thời gian làm:</label>
                            <span class="item__content">{{ examInfo.totalTime }}</span>
                          </div>
                        </div>
                      </div>  
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="exercise-detail__questions position-rel">
              <div class="exercise-detail__list">
                <div
                  v-for="(item, index) of questionsSaved"
                  :id="`question_item_${item.questionId}`"
                  class="item position-rel content-1"
                  :class="{'evt-none': examInfo && ((examInfo.isWork && examInfo.isWork === statusExamDone) || examInfo.isEndTime)}"
                  :key="index"
                >
                    <div class="question-group" v-if="item && item.type && item.type === typeGroup">
                      <PreviewQuestion 
                        :dataSource="item"
                        :questions="questionsSaved"
                        :location="positionQuestionWork"
                        :preview="true"
                        :questionsData="item"
                        :isListQuestion="true"
                        :isDontShowResultSaved="checkExamShowResult()"
                        @formatQuestion="getInfoQuestion"
                        @getResultQuestion="getResultQuestion"
                        @answerMissing="handleAnswerMissing"
                      />
                      <div class="questions-child" v-if="item.listQuestionChild">
                        <div class="questions-child__item" v-for="(child, pos) of item.listQuestionChild" :key="pos">
                          <PreviewQuestion 
                            v-if="child"
                            :dataSource="child"
                            :location="pos"
                            :parentIndex="index"
                            :isQuestionChild="true"
                            :preview="true"
                            :questionsData="item"
                            :questions="item.listQuestionChild"
                            :isListQuestion="true"
                            :isDontShowResultSaved="checkExamShowResult()"
                            @formatQuestion="getInfoQuestion"
                            @writedAnswer="handleWriteAnswer($event, item)"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="question-single" v-else-if="item">
                      <PreviewQuestion 
                        :dataSource="item"
                        :location="positionQuestionWork"
                        :preview="true"
                        :isListQuestion="true"
                        :isDontShowResultSaved="checkExamShowResult()"
                        @getResultQuestion="getResultQuestion"
                        @formatQuestion="getInfoQuestion"
                        @answerMissing="handleAnswerMissing"
                        @writedAnswer="handleWriteAnswer"
                      />
                    </div>
                </div>
              </div>
              <div class="overlay-question" v-if="valVituralKeyboard.location > -1 && screenWidth > 991 && questionCurr !== 0" @click="resetValKeyboard"></div>
            </div>
          </div>
        </transition>
      </template>
      <template v-slot:viewer_sidebar_icon>
        <a href="javascript:;" :class="{'active': keySidebarActive === 'link'}" @click="openSidebar('link')"><i class="icon-exam-ebook font-size-24"></i></a>
      </template>
      <template v-slot:viewer_sidebar_content>
        <div class="sidebar-link" v-if="keySidebarActive === 'link'">
          <div class="sidebar__link__result">
            <div class="book-viewer__sidebar__contents__wrap">
              <b-tabs class="sidebar__tabs">
                <b-tab active>
                  <template v-slot:title>Đề thi</template>
                  <div class="sidebar__link__file" @click="previewDocExamFile">
                    <PreviewBookImg v-if="examInfo && examInfo.fileNameExam" :totalPage="examInfo.totalPageExam" :fileName="examInfo.fileNameExam" :scale="1" />
                    <img v-else class="book-viewer__sidebar__contents__wrap" :src="examInfo.thumbnail ? `${urlImg}/${examInfo.thumbnail}` : img404" :alt="examInfo.name">   
                  </div>
                </b-tab>
                <b-tab>
                  <template v-slot:title>Hướng dẫn</template>
                  <div class="sidebar__link__file" @click="previewDocGuide">
                    <PreviewBookImg v-if="examInfo && examInfo.fileNameAnwser" :totalPage="examInfo.totalPageAnswer" :fileName="examInfo.fileNameAnwser" :scale="1" />  
                  </div>
                </b-tab>
              </b-tabs>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:viewer_toggle_cat_name>Thông tin</template>
      <template v-slot:viewer_footer_center>
        <SliderNameQuestion v-if="questionList && questionList.length > 0 && calLoadedPage" :dataSource="questionList" :isHideNextPrevCat="true" :isDontShowResult="checkExamShowResult()" />
        <!-- :scrollOffset="valEvtScrollQuestion" -->
      </template>
      <template v-slot:viewer_footer_right>
        <a
          v-if="examInfo && (!examInfo.isWork || examInfo.isWork !== statusExamDone)"
          href="javascript:;"
          class="btn btn-main font-size-16 font-sanpro-semibold border-rd-20"
          :class="{'disabled': examInfo && (examInfo.isWork && examInfo.isWork === statusExamDone)}" 
          @click="handleSendExamQuestions"
        >Nộp bài</a>
        <a
          v-else
          href="javascript:;"
          class="btn btn-main font-size-16 font-sanpro-semibold border-rd-20"
          @click="resetAnswers"
        >Làm lại</a>
      </template>
      <template v-slot:viewer_sidebar_cat_head>
        <h2 class="book-viewer__cats__title primary-color-txt font-size-24 font-sanpro-semibold book-viewer__cats__wrap">
          Thông tin
        </h2>
      </template>
      <template v-slot:viewer_sidebar_cat_body>
        <ExamSidebar v-if="examInfo" :dataSource="examInfo" />
      </template>
      <template v-slot:viewer_footer>
        <!-- <VituralKeyboard v-if="valVituralKeyboard.location > -1 && screenWidth > 991" :class="{'open-cat': openBookCats, 'over-height': valVituralKeyboard && valVituralKeyboard.isOverHaflScreen}" /> -->
        <div class="show-document" v-if="showMoalGuideExam">
          <div class="inner-content js-model active">
            <ModalPreviewDocMedia />
            <div class="js-background-model active" @click="handleOffModal"></div>
          </div>
        </div>
      </template>
    </Viewer>
  </div>
</template>

<script>
    import {mapGetters, mapActions, mapState} from 'vuex';
    import { TYPE_GROUP, TYPE_DRAW_SHAPE_ANSWER, TYPE_DOWN_ANSWER, TYPE_FILL_BLANK, TYPE_SELECT, TYPE_MATH_COL, TYPE_RADIO } from '@/modules/question/preview-question/_store/constants'
    import vueCustomScrollbar from 'vue-custom-scrollbar'
    import { APP_CONFIG } from '@/utils/constants'
    import PreviewQuestion from '@/modules/question/preview-question/PreviewQuestion.vue'
    import CountDown from '@/components/CountDown.vue'
    import { getQuestionsSidebar, getQuestionDetail, getQuestionsByCat, getExamDetail, getQuestionListOfOtherOrThematic, getCatOfExerciseOtherOrThematic, sendExamWorked, resetResultCorrectQuestionExam, getQuestionListInSidebarOfThematicOrOther, saveQuestionExamWorked, updateExamTimeWorked } from './../../_api/'
    import { STORE_KEY, LOCAL_SAVE_QUESTIONS_WORKED, LOCAL_SAVE_EXERCISE_CLASS, LOCAL_QUESTIONS_DATA, TYPE_EXERCISE_OTHER, EXAM_WORKED_DONE } from "./../../_store/constants";
    import ExerciseQuestionList from './../../_components/ExerciseQuestionList.vue'
    import VituralKeyboard from '@/modules/question/preview-question/VituralKeyboard.vue'
    import { STORE_KEY as STORE_KEY_QUESTION } from '@/modules/question/preview-question/_store/constants'
    import Viewer from '@/layouts/Viewer.vue'
    import { scrollTo, callTimeDiff } from '@/helpers/functions';
    import PreviewBookImg from '@/components/content-files/PreviewBookImg.vue';
    import ModalPreviewDocMedia from '@/components/content-files/ModalPreviewDocMedia.vue'
    import moment from 'moment'
    import SliderNameQuestion from './../../_components/SliderNameQuestion.vue'
    import ExamSidebar from './../../_components/exam/ExamSidebar.vue'
    import { setContentMediaEditorShow } from '@/modules/question/preview-question/_store/helperQuestionContent'
    const img404 = require(`@/assets/images/img_404.jpg`)
   
    export default {
        name: 'ExamQuestion',
        components: {
          vueCustomScrollbar,
          PreviewQuestion,
          ExerciseQuestionList,
          VituralKeyboard,
          CountDown,
          Viewer,
          PreviewBookImg,
          ModalPreviewDocMedia,
          SliderNameQuestion,
          ExamSidebar
        },
        data() {
          return {
            typeGroup: TYPE_GROUP,
            typeDrawShape: TYPE_DRAW_SHAPE_ANSWER,
            typeDownAnswer: TYPE_DOWN_ANSWER,
            typefillBlank: TYPE_FILL_BLANK,
            typeSelect: TYPE_SELECT,
            typeMatchCol: TYPE_MATH_COL,
            cdnUrl: APP_CONFIG.cdnUrl,
            urlImg: APP_CONFIG.urlQuestionImg,
            settingsViewBookSidebar: {
              maxScrollbarLength: 300,
            },
            collapseOpen: '',
            typeOpenSidebar: {},
            isOpenSidebar: false,
            keySidebarActive: '', // search ||'link'
            openBookCats: false,
            openSidebarMobile: false,
            showGuideContent: false,
            tabGuideActive: 0,
            questionindexActive: null,
            questionsSaved: [],
            questionList: [],
            questionsLoaded: [],
            question: null,
            bookRelates: [],
            arrResultCorrect: [],
            examInfo: null,
            breadCrumbCurr: [],
            txtMissingQuestionGroup: '',
            indexCatCurr: 0,
            thematicCatLength: 0,
            authInfo: {},
            catsFlat: [],
            setValQuestionChange: {},
            handleNextPrevCat: '', //next or prev
            positionQuestionWork: 0,
            showMoalGuideExam: false,
            statusExamDone: EXAM_WORKED_DONE,
            valEvtScrollQuestion: 0,
            startTimeExam: 0,
            totalTimeToDo: 0,
            calLoadedPage: false,
            img404
          }
        },
        computed: {
          ...mapState(STORE_KEY, ['paramsFilterExOtherThematic']),
          ...mapState('auth', ['loginPopupData']),
          ...mapState(STORE_KEY_QUESTION, ['valVituralKeyboard']),
          ...mapGetters({
              actionCheckQuestion: `common/actionCheckQuestion`,
              docPreview: `common/docPreview`,
          }),
          routerParams() {
            return this.$route.params;
          },
          classId() {
            return parseInt(this.$route.params.classId);
          },
          subjectId() {
            return parseInt(this.$route.params.subjectId);
          },
          screenWidth() {
            return window.innerWidth;
          },
          examId() {
            return parseInt(this.$route.params.id);
          },
          typeId() {
            return parseInt(this.$route.params.typeId);
          },
          questionCurr() {
            return parseInt(this.$route.params.question);
          },
          ...mapState('common', ['versionApp'])
        },
        watch: {
          // '$route.params.question': 'getInfoQuestion',
          actionCheckQuestion(newVal) {
            !newVal && this.setQuestionResult();
          },
          '$route.query.cauhoi': 'scrollToQuestion',
          valVituralKeyboard(newVal) {
            // if(newVal.ref) {
              // console.log('Change new val for keyboard: ', newVal);
            //   document.getElementById(newVal.ref).value = newVal.val;
            //   document.getElementById(newVal.ref).focus();
            // }
          },
          docPreview (newVal) {
            this.showMoalGuideExam = newVal && Object.keys(newVal).length > 0 ? true : false
          }
        },
        created() {
          // this.authInfo = getAuth();
        },
        mounted () {
          this.startTimeExam = new Date();
          this.initPage()
          this.getInfoSaveLocal()
        },
        beforeDestroy () {
          !this.examInfo.isEndTime && this.examInfo.isWork !== this.statusExamDone && this.handleUpdateTimeWorked()
        },
        destroyed () {
          this.toggleModalPreview(false)
          // this.resetValKeyboard();
          // localStorage.removeItem(LOCAL_SAVE_QUESTIONS_WORKED)
          // localStorage.removeItem(LOCAL_QUESTIONS_DATA)
        },
        methods: {
            ...mapActions('common', ['setLoading', 'setActionCheckQuestion', 'toggleModalPreview', 'setDocPreviewContent']),
            ...mapActions(STORE_KEY_QUESTION, ['setVituralKeyVal', 'setQuestionData4CheckAnswer', 'setQuestionList4CheckAnswer']),
            moment,

            initPage () {
              let self = this
              // self.setLoading(true)
              Promise.all([this.getQuestionListOfSidebar(), this.getExamInfo()]);
            },

            getQuestionNewExam() {
              // this.setLoading(true)
              Promise.all([this.getQuestionListOfSidebar(), this.fetchQuestionList()]).finally(() => this.setLoading(false))
            },

            getInfoSaveLocal() {
              // let practiceData = localStorage.getItem(LOCAL_SAVE_EXERCISE_CLASS);
              let questionData = localStorage.getItem(LOCAL_QUESTIONS_DATA);
             
              if(questionData && questionData !== null && questionData !== undefined) {
                this.questionsSaved = JSON.parse(questionData);
                setTimeout(() => {
                  this.setQuestionActive()
                }, 400)
                // this.setQuestionListWorked(this.questionsSaved)
              } else {
                this.fetchQuestionList()
              }
            },

            getExamInfo() {
              let self = this;
              getExamDetail(self.examId).then(res => {
                if (res && res.data && !res.errors) {
                  self.examInfo = {...res.data, isEndTime: false}
                  self.totalTimeToDo = res.data.totalTime ? parseInt(res.data.timeToDo) - parseInt(res.data.totalTime) : parseInt(res.data.timeToDo)
                  // console.log('info exam: ', parseInt(res.data.timeToDo) - parseInt(res.data.totalTime))
                  // res.data.questionLast && res.data.questionLast > 0 && this.gotoQuestion(res.data.questionLast)
                  if (!self.calLoadedPage) {
                    self.calLoadedPage = true
                  }
                }
              })
            },

            getQuestionListOfSidebar() {
              let self = this;
              // self.setLoading(true)
              self.questionList = []
              
              getQuestionListInSidebarOfThematicOrOther(0, self.examId).then(res => {
                self.questionList = res && res.data && !res.errors ? res.data : []
                if(res && res.data && res.data.length > 0) {
                  self.questionsSaved && self.setQuestionListSidebarWorked(self.questionsSaved)
                }
              }).catch().finally(() => self.setLoading(false))
            },

            getInfoQuestion() {
              let self = this;

              self.question = null;
              // Hidden guide content
              self.showGuideContent = false;
              // self.arrResultCorrect = [];
              self.questionindexActive = self.$route.params.question;
              if(self.questionindexActive > 0) {
                // self.setLoading(true)
                let questionId = self.questionList[self.questionCurr - 1].questionId;
                let questionsLocalStorage = JSON.parse(localStorage.getItem(LOCAL_SAVE_QUESTIONS_WORKED));

                if(questionsLocalStorage && questionsLocalStorage !== null && questionsLocalStorage !== undefined && questionsLocalStorage.length > 0) {
                  let indexQuestionSave = questionsLocalStorage.findIndex(ques => ques.questionId === questionId);
                  if(indexQuestionSave > -1) {
                    self.question = questionsLocalStorage[indexQuestionSave];
                    self.setLoading(false);
                  } else {
                    self.getQuestionDetail(questionId, questionsLocalStorage);
                  }
                } else {
                  self.getQuestionDetail(questionId);
                }

                self.setQuestionCurr();
              }
            },

            getQuestionDetail(questionId, dataQuestion = []) {
              let self = this;
              // Get question detail
              getQuestionDetail(questionId).then(res => {
                if(res && res.data && !res.errors) {
                  self.question = res.data
                  let dataSave = dataQuestion.length === 0 ? [res.data] : [...dataQuestion, res.data]
                  self.saveLocalQuestion(dataSave)
                }
              }).catch().finally(() => self.setLoading(false))
            },

            saveLocalQuestion(data) {
              let dataSave = JSON.stringify(data)
              localStorage.setItem(LOCAL_SAVE_QUESTIONS_WORKED, dataSave)
            },

            setQuestionCurr() {
              let self = this;
              // Set question current
              self.questionList.map((que, index) => {
                que['current'] = parseInt(index) === parseInt(self.questionindexActive) -1
              })
            },

            setQuestionResult () {
            },

            logQuestionWorked(status) {
              this.question['isTrue'] = status === 'success'
              this.question['isWorked'] = true
            },

            openSidebar(type) {
              if(type !=null){
                this.typeOpenSidebar = {type, isOpen: type === this.keySidebarActive ? false : true}
                this.keySidebarActive = type !== this.keySidebarActive ? type : ''
              }
            },

            scrollToQuestion () {
              let positionQuestion = this.$route.query.cauhoi ? parseInt(this.$route.query.cauhoi) : 1
              if (this.questionList && this.questionList.length > 0) {
                let questionId = this.questionList[positionQuestion - 1].questionId
                this.gotoQuestion(questionId)
                
              }
              // Set loaded data mounted true
              if (!this.calLoadedPage) {
                this.calLoadedPage = true
              }
            },

            gotoQuestion (id) {
              let elem = document.getElementById(`question_item_${id}`)
              if(elem) {
                let topPos = elem.offsetTop
                scrollTo(document.getElementById('viewer_body'), topPos, 600)
              }
            },

            async checkAnswer () {
              this.resetValKeyboard();
              await this.setActionCheckQuestion(true);
              let timeWorked = this.calTotalTimeWorked()

              localStorage.setItem( LOCAL_QUESTIONS_DATA, JSON.stringify(this.questionsSaved) )
              // Save question worked into DB
              saveQuestionExamWorked({question: [this.questionsSaved[this.positionQuestionWork]], examId: this.examId, totalTimeExam: timeWorked})
            },

            calTotalTimeWorked () {
              let timeCal = callTimeDiff(this.startTimeExam)
              return this.examInfo.totalTime ? parseInt(this.examInfo.totalTime) + timeCal.minute : timeCal.minute;
            },

            async handleSendExamQuestions () {
              let self = this
              // await self.checkAnswer()
              // let questionsLocalStorage = JSON.parse(localStorage.getItem(LOCAL_SAVE_QUESTIONS_WORKED));
              // let questionWorked = this.questionsSaved.filter(ques => ques.statusWorked)
              let timeWorked = this.calTotalTimeWorked()
              // self.setLoading(true)
              // sendExamWorked({question: questionWorked}).then(res => {
              sendExamWorked({examId: self.examId, totalTimeExam: timeWorked}).then(res => {
                if(res && !res.errors) {
                  // self.$toast.success('Bạn đã hoàn thành Bài thi');
                  self.examInfo.isWork = true
                  Promise.all([self.getQuestionListOfSidebar(), self.getExamInfo(), self.fetchQuestionList()]);
                }
              }).finally(() => self.setLoading(false));
            },

            handleAnswerMissing(valErr) {
              // if(this.question.type === TYPE_GROUP) {
              //   this.txtMissingQuestionGroup = valErr;
              // }
              // setTimeout(() => {
              //   this.showGuideContent = false;
              // }, 5)
            },

            getResultQuestion(val) {
              this.arrResultCorrect = val;
            },

            getQuestionData(val) {
              if(this.questionindexActive > 0 ) {
                  if(this.questionList[this.questionindexActive - 1] && this.questionList[this.questionindexActive - 1]['current']) {
                    this.questionList[this.questionindexActive - 1]['current'] = false;
                  }
                  if(!val) {
                    this.questionList.map(ques => {
                      ques.success && delete ques.success;
                      ques.error && delete ques.error;
                      ques.answerStatus && delete ques.answerStatus;
                    })
                  }
                  this.questionindexActive = 0;
                  this.$router.push({name: 'exerciseExamQuestion', params: {...this.routerParams, id: this.examId, question: 0}});
              }
              if(!this.questionsSaved) {
                this.fetchQuestionList();
              }
            },

            fetchQuestionList() {
              let self = this;
              // self.setLoading(true);
              let questionsLocal = localStorage.getItem(LOCAL_QUESTIONS_DATA)
              if ( questionsLocal && questionsLocal !== null && questionsLocal !== undefined ) {
                self.questionsSaved = JSON.parse(questionsLocal)
                // self.examInfo.isWork && self.setQuestionsWorked()
                self.examInfo.isWork === 1 && self.setQuestionsWorked()
                // self.setQuestionListWorked(self.questionsSaved)
              } else {
                getQuestionListOfOtherOrThematic(0, self.examId).then(res => {
                  if(res && res.data && !res.errors) {
                    let questionReplaceContent = res.data.map(ques => {
                      let typeQuestion = ques.type === TYPE_GROUP ? 'group' : 'single'
                      ques = setContentMediaEditorShow({...ques}, typeQuestion)
                      return ques
                    })

                    self.questionsSaved = questionReplaceContent;
                    // self.examInfo.isWork && self.setQuestionsWorked()
                    self.examInfo.isWork === 1 && self.setQuestionsWorked()
                    localStorage.setItem( LOCAL_QUESTIONS_DATA, JSON.stringify(questionReplaceContent) );
                   
                    if (res.data && res.data.length === 0) {
                      self.handleNextPrevCat === 'next' && self.nextCatBook()
                      self.handleNextPrevCat === 'prev' && self.prevCatBook()
                    }
                    // await render question element for cal scroll & curr question
                    setTimeout(() => {
                      self.setQuestionActive()
                    }, 600)
                  }
                })
                .catch().finally(() => self.setLoading(false));
              }
            },

            /**
            * Support display result question
            **/
            setQuestionsWorked () {
              let self = this
              self.questionsSaved.map(ques => {
                if (!ques['isWorked']) {
                  ques['isWorked'] = true
                  ques['isNoAnswer'] = true
                }
                ques.listQuestionChild && ques.listQuestionChild.length > 0 && ques.listQuestionChild.map(child => {
                  if (!ques['isWorked']) {
                    child['isWorked'] = true
                    child['isNoAnswer'] = true
                  }
                })
              })

              self.questionList.map(ques => {
                if (!ques['isWorked']) {
                  ques['isWorked'] = true
                }
                if (!ques['questionLast'] || ques['questionLast'] !== self.examInfo.questionLast) {
                  ques['isNoAnswer'] = true
                }
              })
            },

            setQuestionActive () {
              if (this.examInfo && this.examInfo.questionLast && this.examInfo.questionLast > 0 && this.questionList) {
                let indexQuestion = this.questionList.findIndex(ques => ques.questionId === this.examInfo.questionLast)
                let positionQueston = indexQuestion > -1 ? indexQuestion + 1 : 1
                this.$route.query.cauhoi != positionQueston && this.$router.replace({ query: {cauhoi: positionQueston} })
              }

              if ( this.questionList && this.questionList.length > 0 ) {
                this.questionList.map(ques => {
                  let offsetTopElm = document.getElementById(`question_item_${ques.questionId}`).offsetTop
                  ques['offsetTop'] = offsetTopElm
                })
              }
              this.setLoading(false)
            },

            setQuestionListSidebarWorked (data) {
              let self = this
              data.map((ques, index) => {
                if (ques.answerChoosed || ques.statusWorked) {
                  this.questionList[index]['statusWorked'] = true
                }
              })
            },

            async resetAnswers() {
              let self = this;
              // self.setLoading(true)
              self.questionsSaved = []
              await localStorage.removeItem(LOCAL_SAVE_QUESTIONS_WORKED);
              await localStorage.removeItem(LOCAL_QUESTIONS_DATA);
              resetResultCorrectQuestionExam(self.examId).then(res => {
                if(res && !res.errors) {
                  self.examInfo.isWork = false
                  self.startTimeExam = new Date()
                  // self.examInfo.isWork && this.$router.push({name: 'exerciseExamResult', params: { id: self.examInfo.examId, typeId: self.typeId }})
                  Promise.all([self.getQuestionListOfSidebar(), self.getExamInfo(), self.fetchQuestionList()]);
                  // self.$toast.success('Thực hiện làm lại bài tập thành công!')
                }
              })
            },

            async directExerciseCat(val) {
              this.routerParams.question && delete this.routerParams.question
              this.$router.push({name: 'exerciseExamDetail', params: {...this.routerParams, id: val.examId}})
            },

            handleCheckAnswerResult() {
              if(this.question.type === TYPE_GROUP) {
                this.txtMissingQuestionGroup = '';
              }
              (this.question.type !== this.typeDrawShape && this.question.type !== this.typeDownAnswer) && this.checkAnswer();
            },

            resetValKeyboard() {
              this.valVituralKeyboard && this.setVituralKeyVal({});
            },

            handleEndTime (val) {
              // if(parseInt(val.minute) === 2) {
              this.examInfo.isEndTime = true
              this.handleUpdateTimeWorked()
              // this.examInfo.isWork = true
              // }
            },

            handleWriteAnswer (val, parent = null) {
              let questionChildIndex = -1
              // console.log('Handle write val: ', val, this.positionQuestionWork);
              this.positionQuestionWork = this.questionsSaved.findIndex(ques => ques.questionId === (parent ? parent.questionId : val.question.questionId))
              if (parent) {
                questionChildIndex = parent.listQuestionChild.findIndex(child => child.questionId === val.question.questionId)
              }
              // console.log(indexQuestionWork);
              if (this.positionQuestionWork > -1) {
                this.questionList[this.positionQuestionWork]['statusWorked'] = true

                if (questionChildIndex > -1) {
                  parent.listQuestionChild[questionChildIndex]['answerChoosed'] = val.answers
                  parent.listQuestionChild[questionChildIndex]['examId'] = this.examId
                  this.setQuestionData4CheckAnswer({...parent.listQuestionChild[questionChildIndex]})
                } else {
                  this.questionsSaved[this.positionQuestionWork]['answerChoosed'] = val.answers
                  this.questionsSaved[this.positionQuestionWork]['examId'] = this.examId
                }

                if (parent && parent.listQuestionChild[questionChildIndex].type === TYPE_RADIO) {
                  parent.listQuestionChild[questionChildIndex].answers.map(ans => {
                    ans.answerContent = null
                  })
                } else if (!parent && this.questionsSaved[this.positionQuestionWork].type === TYPE_RADIO) {
                  this.questionsSaved[this.positionQuestionWork].answers.map(ans => {
                    ans.answerContent = null
                  })
                }

                if (parent && questionChildIndex > -1) {
                  this.setQuestionData4CheckAnswer({...parent.listQuestionChild[questionChildIndex], isGroup: true, parent: parent.questionId})
                } else {
                  // Reset parent answer
                  this.setQuestionData4CheckAnswer({...this.questionsSaved[this.positionQuestionWork]})
                }
                this.setQuestionList4CheckAnswer([...this.questionsSaved])
                this.checkAnswer()
              }
            },

            previewDocGuide () {
              if ( this.examInfo && this.examInfo.fileNameAnwser ) {
                this.showMoalGuideExam = true
                //console.log('preview: ', data);
                this.setDocPreviewContent({...this.examInfo, path: this.examInfo.pathAnwser, bookInfo: {fileName: this.examInfo.fileNameAnwser, totalPage: this.examInfo.totalPageAnswer}});
                this.toggleModalPreview(true)
              }
            },

            previewDocExamFile () {
              if ( this.examInfo && this.examInfo.fileNameExam ) {
                this.showMoalGuideExam = true
                this.setDocPreviewContent({...this.examInfo, path: this.examInfo.pathExam, bookInfo: {fileName: this.examInfo.fileNameExam, totalPage: this.examInfo.totalPageExam}});
                this.toggleModalPreview(true)
              }
            },

            handleOffModal() {
              this.toggleModalPreview(false)
              this.setDocPreviewContent({})
            },

            checkExamShowResult () {
              return this.examInfo && this.examInfo.isWork && this.examInfo.isWork === this.statusExamDone ? false : true
            },

            handleScrollBodyQuestion (val) {
              this.valEvtScrollQuestion = val
            },

            handleUpdateTimeWorked () {
              let timeTotal = this.calTotalTimeWorked()
              updateExamTimeWorked(this.examInfo.examId, timeTotal)
            }
        },
    }
</script>

<style lang="scss" scoped>

  #main_app {
    height: auto;
  }

  .private-fa-times {
    position: absolute;
    top: 3px !important;
    cursor: pointer;
    right: 2px !important;
  }

  .answer-2{
    p{
      width:160px;
    }
  }
  .questions-child {
    &__item {
      &:first-child {
        margin-top: 30px;
      }

      &:not(:last-child) {
        margin-bottom: 30px;
      }
    }
  }

  .exercise-result {
    &__head {
      border-bottom: 2px solid $color_border_main;
      padding: 15px 0;
    }

    &__body {
      padding: 20px 0 10px;

      .item {
        margin-bottom: 15px;

        &__label {
          @extend .display-block;
          @extend .secondary-color-txt;
          margin-bottom: 5px;
        }

        &__content {
          @extend .primary-color-txt;
          @extend .font-sanpro-light;

          &--score {
            @extend .font-sanpro-semibold;
            @extend .font-size-28;
          }
        }
      }
    }
  }

  .exercise-detail {

    &__sidebar {
      position: fixed;
      top: 50px;
      z-index: 1; 
    }

    &__questions {
      max-width: 80%;
      margin: 0 auto;
      padding: 30px 15px;
    }

    &__direct {
      >* {
        &:not(:first-child) {
          margin-left: 20px;
        }
      }
    }

    &__action {
      >a {
        width: 140px;
        line-height: 1.1;
        letter-spacing: 0.03em;
        margin-left: 20px;
      }
    }

    &__back {
      margin-bottom: 20px;
      @extend .display-inline-block;
    }

    &__cats {
      &__title {
        @extend .border-0;
        @extend .margin-0;

        i {
          margin-left: 20px;
        }
      }

      &__list {
        a {
          width: 65px;
          height: 35px;
          line-height: 35px;
          @extend .display-inline-block;
          @extend .text-center;
          margin-bottom: 18px;
          @extend .font-size-15;
          @extend .font-sanpro-semibold;
          border: 1px solid transparent;
          border-radius: 4px;
          @extend .secondary-color-txt;

          &.primary-color {
            @extend .primary-color;
          }

          &.item {

            &:not(:nth-child(4n)) {
              margin-right: 10px;
            }
          }

          &:hover, &.curr {
            border-color: $primary_color;
          }

          &:hover, &.curr, &.success, &.error {
            @extend .primary-color;
          }

          &.success {
            @extend .secondary-bg-color;
            border-color: $secondary_color;
          }

          &.error {
            @extend .four-bg-color;
            border-color: $four_color;
          }
        }
      }

      &__breadcrumb {
        margin-bottom: 30px;
        ul {
          li {
            @extend .display-flex;
            @extend .full-width;
            margin-bottom: 10px;

            a {
              @extend .secondary-color-txt;
              @extend .font-size-16;
            }

            .btn-reset {
              width: 26px;
              height: 26px;
              @extend .display-flex-center;
              @extend .justify-content-center;
              @extend .border-rd-50;
              margin-left: 20px;
              @extend .btn-2;
              cursor: pointer;
            }

            &.active {

              a {
                @extend .primary-color;
                @extend .font-sanpro-semibold;
              }
            }

            &:last-child {
              a {
                padding-top: 3px;
                max-width: calc(100% - 45px);
                @extend .word-excerpt;
              }
            }
          }
        }
      }
    }

    &__feedback {
      margin-bottom: 38px;
    }

    &__list {
      margin-bottom: 35px;

      .item {
        margin-bottom: 40px;
      }
    }

    &__guide {
      h2 {
        margin-bottom: 13px;
      }

      p {
        @extend .primary-color-txt;
      }
    }

    @media screen and ( min-width: 576px ) and ( max-width: 1199px ) {
      &__cats {
        width: 365px;
      }
    }

    @media screen and ( min-width: 992px ) and ( max-width: 1199px ) {
      &__cats {
        padding: 25px 0;
      }
    }

    @media screen and ( max-width: 991px ) {
      &__body {
        padding: 0!important;
      }
      &__sidebar {
        &__icons {
          background: transparent;
        }

        &.active {
          -webkit-transform: translate(0, 0px);
          transform: translate(0, 0px);                    
        }
      }
    }

    @media screen and ( min-width: 576px ) and ( max-width: 991px ) {
      &__questions {
        max-width: 85%;
      }
      &__cats {
        // padding: 25px 15px;
        padding: 25px 0;
      }
      &__sidebar {
        -webkit-transform: translate(75vw, 0px);
        transform: translate(75vw, 0px);
      }
    }
              @media screen and ( min-width: 768px ) and ( max-width: 991px ) {
              }

              @media screen and ( max-width: 991px ) {
                &__questions {
                  padding: 25px 15px;
                }
                &__feedback {
                  margin-bottom: 25px;
                }
              }

              @media screen and ( max-width: 575px ) {
                &__questions {
                  max-width: 95%;
                }
                &__cats {
                  width: 300px;
                  // padding: 20px 10px;
                  padding: 20px 0;
                  -webkit-transform: translate(-300px, 0px);
                  transform: translate(-300px, 0px);

                  &__list {
                    a {
                      width: 55px;
                      height: 30px;
                      line-height: 30px;
                      margin-bottom: 15px;

                      &:not(:nth-child(4n+4)) {
                        margin-right: 15px;
                      }
                    }
                  }
                }

                &__guide {
                  h2 {
                    font-size: 20px;
                  }

                  &__content {
                    font-size: 15px;
                  }
                }

                &__action >a {
                  width: 105px;
                }

                &__direct > *:not(:first-child), &__action >a {
                  margin-left: 15px;
                }

                &__sidebar {
                  -webkit-transform: translate(80vw, 0px);
                  transform: translate(80vw, 0px);
                }
              }
            }
</style>
